import type { ApiResponse, ApprovalCardView, ApproverType } from '@evi/shared';
import { api } from './api';

/**
 * Today, Approvals in Admin (Warren, 29 Oct 2026, item 2): the Api's views (apps/api routes/admin/approvals.ts). Every
 * check is the Api's: which cards the caller sees (the approver types they hold), and whether they may decide each one
 * (can_decide, with the reason when not). The page shows those answers and never decides them itself.
 */
export interface ApprovalsList { holds: ApproverType[]; can_name_approvers: boolean; waiting: ApprovalCardView[]; decided: ApprovalCardView[] }
export interface ApprovalDetail {
  card: ApprovalCardView;
  now: { hash: string; changed: boolean; ready: boolean; errors: string[]; money: ApprovalCardView['money'] } | null;
}
export interface ApproversView { can_change: boolean; types: ApproverType[]; staff: Array<{ id: string; name: string; role: string; types: ApproverType[] }> }

export const fetchApprovals = () => api.get('admin/approvals', { retry: 0 }).json<ApiResponse<ApprovalsList>>().then((r) => r.data!);
export const fetchApproval = (id: string) => api.get(`admin/approvals/${id}`, { retry: 0 }).json<ApiResponse<ApprovalDetail>>().then((r) => r.data!);
export const approveCard = (id: string, reviewHash: string) =>
  api.post(`admin/approvals/${id}/approve`, { json: { review_hash: reviewHash }, retry: 0 }).json<ApiResponse<{ status: string; card: ApprovalCardView }>>().then((r) => r.data!);
export const declineCard = (id: string, note: string) =>
  api.post(`admin/approvals/${id}/decline`, { json: { note }, retry: 0 }).json<ApiResponse<{ status: string; card: ApprovalCardView }>>().then((r) => r.data!);
export const fetchApprovers = () => api.get('admin/approvers', { retry: 0 }).json<ApiResponse<ApproversView>>().then((r) => r.data!);
export const setApprover = (userId: string, type: ApproverType, grant: boolean) =>
  api.post('admin/approvers', { json: { user_id: userId, type, grant }, retry: 0 }).json<ApiResponse<{ changed: boolean }>>().then((r) => r.data!);

export { ageLabel, cardMoneySentence, cardWho, declineSentence, expiryLabel, resultLine, waitingLabel } from './approvalsView';
